const defaultDelay = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export function createNetworkRetryMiddleware({ maxRetries = 2, _delay = defaultDelay } = {}) {
  return next =>
    async (url, init = {}) => {
      const method = (init.method || 'GET').toUpperCase();

      // Jen GET requesty se retryují
      if (method !== 'GET') {
        return next(url, init);
      }

      let lastError;
      for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
          return await next(url, init);
        } catch (err) {
          // Jen TypeError (network error) se retryuje
          if (!(err instanceof TypeError)) {
            throw err;
          }
          lastError = err;
          if (attempt < maxRetries) {
            const delay = (attempt + 1) * 1000;
            await _delay(delay);
          }
        }
      }
      throw lastError;
    };
}
